import { useQuery } from "@tanstack/react-query";
import { formatDate } from "date-fns";
import {
  ArrowRightIcon,
  CalendarIcon,
  CheckIcon,
  ClockIcon,
  FormIcon,
} from "lucide-react";

import { formatDateAt } from "simplydo/core/dates";
import { initUseQuery } from "simplydo/core/query";
import { ButtonLink } from "simplydo/react/ui/button";
import { CardContent } from "simplydo/react/ui/card";
import { H3, H4, Subheader } from "simplydo/react/ui/header";
import { Icon } from "simplydo/react/ui/icon";
import { Label } from "simplydo/react/ui/label";

import api from "api";

import {
  HomeRow,
  HomeRowActions,
  HomeRowContainer,
  HomeRowContent,
  HomeRowIcon,
} from "../HomeUI";
import { getDateStatus } from "../dateStatus";
import HomeBlock from "./HomeBlock";

const PollsBlock = () => {
  const dashboardQuery = useQuery(initUseQuery(api.users.dashboard, []));

  const polls = dashboardQuery.data?.polls ?? [];

  if (!polls.length) return null;

  const incompletePolls = polls.filter((poll) => !poll.hasResponded);

  return (
    <HomeBlock>
      <CardContent>
        <H3>
          Make your voice heard
          <Subheader>
            Participate in {incompletePolls.length} active{" "}
            {incompletePolls.length === 1 ? "poll" : "polls"} waiting for your
            response.
          </Subheader>
        </H3>
        <HomeRowContainer>
          {polls.map((poll) => {
            const dateStatus = getDateStatus(poll.deadline);
            return (
              <HomeRow key={poll._id}>
                <HomeRowIcon>
                  <Icon icon={FormIcon} />
                </HomeRowIcon>
                <HomeRowContent>
                  <H4>
                    {poll.name}
                    <Subheader>
                      Posted: {formatDateAt(poll.createdAt)}
                    </Subheader>
                  </H4>
                </HomeRowContent>
                <HomeRowActions>
                  {poll.deadline ? (
                    <Label
                      color={dateStatus?.color}
                      size="small"
                      basic={dateStatus?.basic}
                    >
                      <Icon icon={CalendarIcon} /> {dateStatus?.text}
                    </Label>
                  ) : null}
                  {poll.hasResponded ? (
                    <Label basic>
                      <Icon icon={CheckIcon} />
                      Completed
                    </Label>
                  ) : (
                    <ButtonLink
                      to={`/polls/${poll._id}`}
                      target="_blank"
                      color="primary"
                      variant="soft"
                      size="small"
                    >
                      Respond
                      <Icon icon={ArrowRightIcon} />
                    </ButtonLink>
                  )}
                </HomeRowActions>
              </HomeRow>
            );
          })}
        </HomeRowContainer>
      </CardContent>
    </HomeBlock>
  );
};

export default PollsBlock;
